import { Toro } from '../common/enumerations';

export class ZoneProgressModel
{
    constructor(controllerId: number,
                zoneNumber?: number,
                timeStamp?: Date,
                duration?: number,
                timeRemaining?: number,
                zoneRunningState: Toro.ZoneRunningState = Toro.ZoneRunningState.Idle,
                isManual = false)
    {
        this.controllerId = controllerId;
        this.zoneNumber = zoneNumber;
        this.zoneRunningState = zoneRunningState;
        this.timeStamp = timeStamp;
        this.duration = duration;
        this.timeRemaining = timeRemaining;
        this.isManual = isManual;
    }

    controllerId: number;
    zoneNumber: number;
    zoneRunningState: Toro.ZoneRunningState;
    timeStamp: Date;
    duration: number;
    timeRemaining: number;
    isManual: boolean;
}
